/********************************************************************************



*******************************************************************************/

// var $ = jQuery.noConflict();

//$(document).ready(function () {
jQuery(document).ready(function ($) {


  /* 1. Scroll to top
  ------------------------------------------------------------------------------*/
  $(document).on('scroll', function () {
    if ($(window).scrollTop() > 200) {
      $('.scroll-to-top').addClass('show');
    } else {
      $('.scroll-to-top').removeClass('show');
    }
  });

  $('.scroll-to-top').on('click', function (event) {
    event.preventDefault();
    var verticalOffset = typeof (verticalOffset) != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 500, 'linear');
  });


  /* 2. Off canvas menu
  ------------------------------------------------------------------------------*/
  var $main_nav = $('#mobile-nav');
  var $menu_mode = $main_nav.data('nav-mode');
  var $toggle = $('.js-menu-toggle');

  var defaultData = {
    // maxWidth: false,
    disableAt: false,
    pushContent: $('.l-outline'),
    position: 'right',
    customToggle: $toggle,
    navTitle: false,
    levelTitles: true,
    insertClose: false,
    closeLevels: true,
    disableBody: true,
    removeOriginalNav: true,
    levelSpacing: 20,
    labelBack: 'Wróć',
    labelClose: 'Zamknij',
  };

  if ($menu_mode != 'disabled') {
    var Nav = $main_nav.hcOffcanvasNav(defaultData);

    Nav.on('open', function (event, settings) {
      $('.header').addClass('header--scrolled');
    });
  }

  $toggle.on('click', function (e) {
    e.preventDefault();
    $toggle.toggleClass('is-active');
    $('.header').addClass('header--scrolled');
  });

  // function setMobMenuPadding() {
  //   $headerHeight = $('.header').outerHeight();
  //   $('.nav-wrapper').css('padding-top', $headerHeight + 'px');
  // }
  // setMobMenuPadding();
  // $(window).on("debouncedresize", function( event ) {
  //   setMobMenuPadding();
  // });

  // Hide navigation when user pressed Escape key on keyboard
  $(document).on('keyup', function (e) {
    if (e.keyCode === 27) {
      Nav.close();
    }
  });

  /* 3. Dropdown Menu
  ------------------------------------------------------------------------------*/

  // $('.horizontal-menu .menu-item-has-children > a').on('click', function(e){
  //   e.preventDefault();
  //   $(this).parent().toggleClass('opened');
  // });

  // Hide dropdown after click outside the menu
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.horizontal-menu .menu-item-has-children a').length) {
      $('.horizontal-menu .menu-item-has-children').removeClass('opened');
    }
  });

  $('.horizontal-menu .menu-item-has-children > a').click(function (e) {
    e.preventDefault();
    var $mthis = $(this);
    var $mparent = $mthis.parent();

    $mparent.toggleClass('opened');
  });


  /* 4. Slick slider
  ------------------------------------------------------------------------------*/
  $('.benefit-logos-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          prevArrow: false,
          nextArrow: false,
          dots: true,
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 2,
          prevArrow: false,
          nextArrow: false,
          dots: true,
        },
      }
    ]
  });


  $('.home-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false,
    draggable: false,
    fade: true,
    speed: 1000,
    draggable: true,
    responsive: [{
        breakpoint: 768,
        settings: {
          prevArrow: false,
          nextArrow: false
        }
      },
      {
        breakpoint: 520,
        settings: {
          prevArrow: false,
          nextArrow: false
        },
      }
    ]
  });

  $('.home-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $(slick.$slides).removeClass('is-animating');
  });

  $('.home-slider').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    $(slick.$slides.get(currentSlide)).addClass('is-animating');
  });

  // Team slider
  $('.team-carousel-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    arrows: true,
    dots: true,
    pauseOnHover: false,
    responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          prevArrow: false,
          nextArrow: false,
          dots: true,
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          prevArrow: false,
          nextArrow: false,
          dots: true,
        },
      }
    ]
  });

  /* 5. AOS
  ------------------------------------------------------------------------------*/
  AOS.init({
    once: true,
    disable: 'mobile'
  });
  window.addEventListener('load', AOS.refresh)

  function refreshAOS() {
    AOS.refresh();
  }

  $('img').on('load', _.throttle(refreshAOS, 1000));

  /* 6. Fancybox
  ------------------------------------------------------------------------------*/
  $('[data-fancybox="gallery"]').fancybox({
    arrows: true,
    toolbar: true,
    buttons: [
      "zoom",
      "share",
      // "slideShow",
      "fullScreen",
      // "download",
      "thumbs",
      "close"
    ]
  });

  /* 7. Scoll Animations Init
  ------------------------------------------------------------------------------*/

  AOS.init({
    disable: 'mobile',
    once: true
  });

  window.addEventListener('load', AOS.refresh);

  function refreshAOS() {
    AOS.refresh();
  }

  $('img').on('load', _.throttle(refreshAOS, 1000));


  /* 8. Object Fit Images
    ------------------------------------------------------------------------------*/

  objectFitImages();


  /* 9. Contact Form 7 Fix
    ------------------------------------------------------------------------------*/

  $('.wpcf7-form p:empty').remove();


  /* 10. Accordion
    ------------------------------------------------------------------------------*/

  var allPanels = $('.c-accordion dd').hide();
  var allTitles = $('.c-accordion dt');

  $('.c-accordion__el:first-child > .c-accordion__subtitle').addClass('c-accordion__subtitle--active');
  $('.c-accordion__text--active').slideDown();
  $('.c-accordion__el:first-child > .c-accordion__text').addClass('c-accordion__text--active');

  $('.c-accordion dt > a').click(function (e) {
    e.preventDefault();
    var $this = $(this);
    var $title = $this.parent();
    var $target = $this.parent().next();

    if (!$target.hasClass('c-accordion__text--active')) {
      allPanels.removeClass('c-accordion__text--active').slideUp();
      allTitles.removeClass('c-accordion__subtitle--active');
      $target.addClass('c-accordion__text--active').slideDown();
      $title.addClass('c-accordion__subtitle--active');
    } else {
      allPanels.removeClass('c-accordion__text--active').slideUp();
      allTitles.removeClass('c-accordion__subtitle--active');
    }
    return false;
  });


  /* 11. Equal Heights
  ------------------------------------------------------------------------------*/

  // Example:
  // $('.something').matchHeight();
  $('.grid-elements__el .c-title').matchHeight();
  $('.grid-elements__el p').matchHeight();

  $('.offer__el').matchHeight();
  $('.offer__cnt .c-title').matchHeight();

  // Match Height compatibility with Lazy Load techniques
  function refreshMatchHeight() {
    $.fn.matchHeight._update();
  }
  $('img').on('load', _.throttle(refreshMatchHeight, 1000));


  /* 12. Parallax
------------------------------------------------------------------------------*/

  window.onload = function () {
    lax.setup(); // init

    function updateLax() {
      lax.update(window.scrollY);
      window.requestAnimationFrame(updateLax);
    }

    window.requestAnimationFrame(updateLax);
  };


  /* 13. Fix group widths
  ------------------------------------------------------------------------------*/

  $('.wp-block-group').each(function (index) {
    if ($(this).hasClass('alignfull')) {
      $(this).wrap('<div class="wp-block-group-wrap alignfull"></div>');
    } else if ($(this).hasClass('alignwide')) {
      $(this).wrap('<div class="wp-block-group-wrap alignwide"></div>');
    } else {
      $(this).wrap('<div class="wp-block-group-wrap"></div>');
    }
  });


  /* 14. AJAX Load More
------------------------------------------------------------------------------*/

  $('.js-load-more').click(function () {
    var button = $(this);
    var content_place = $(this).parent();
    var data = {
      'action': 'ajax_load_more',
      'query': theme_settings.posts,
      'page': theme_settings.current_page
    };

    if (!(button.hasClass('c-btn--post-loading-loader') || button.hasClass('c-btn--post-no-more-posts'))) {

      $.ajax({
        url: theme_settings.ajaxurl,
        data: data,
        type: 'POST',
        beforeSend: function (xhr) {
          button.addClass('c-btn--post-loading-loader').find('span').html(theme_settings.loading);
        },
        success: function (data) {
          var tempScrollTop = $(window).scrollTop();
          if (data.length) {
            button.removeClass('c-btn--post-loading-loader').find('span').html(theme_settings.loadmore);
            $(data).insertBefore(content_place);
            theme_settings.current_page++;

            if (theme_settings.current_page == theme_settings.max_page)
              button.removeClass('c-btn--post-loading-loader').addClass('c-btn--post-no-more-posts').find('span').html(theme_settings.noposts);
          } else {
            button.removeClass('c-btn--post-loading-loader').addClass('c-btn--post-no-more-posts').find('span').html(theme_settings.noposts);
          }
          $(window).scrollTop(tempScrollTop);
        }
      });
    }
  });


  /* 15. HTML Canvas
------------------------------------------------------------------------------*/
  function download(url) {
    var a = $("<a style='display:none' id='js-downloder'>")
      .attr("href", url)
      .attr("download", "SportFit Plan zajęć.png")
      .appendTo("body");

    a[0].click();

    a.remove();
  }

  function saveCapture(element) {
    html2canvas(element).then(function (canvas) {
      download(canvas.toDataURL("image/png"));
    })
  }

  $('#btnDownload').click(function () {
    var element = document.querySelector("#capture");
    saveCapture(element)
  })


  /* 15. Isotope
------------------------------------------------------------------------------*/
  var $grid = $('.filter-items').isotope({
    itemSelector: '.filter-item',
    // layoutMode: 'fitRows',
    // fitRows: {
    //   gutter: '.gutter-sizer'
    // }
    // columnWidth: '',
    // percentPosition: true
  });

  // bind filter button click
  $('.filter-nav').on('click', '.c-btn--filter', function () {
    var filterValue = $(this).attr('data-filter');
    $grid.isotope({
      filter: filterValue
    });
  });


  // change is-checked class on buttons
  $('.filter-nav').each(function (i, buttonGroup) {
    var $buttonGroup = $(buttonGroup);
    $buttonGroup.on('click', '.c-btn--filter', function () {
      $buttonGroup.find('.is-checked').removeClass('is-checked');
      $(this).addClass('is-checked');
    });
  });

  // layout Isotope after each image loads
  $grid.imagesLoaded().progress(function () {
    $grid.isotope('layout');
  });

}); // end of jQuery code